import React from 'react';
import styles from './show-more-button.scss';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';
import { useTranslate } from '../../../common/api-providers/use-translate';
import { CONTENT_TOGGLE_BUTTON } from './data-hooks';

type ShowMoreButtonProps = {
  onPreviewExpand?: () => void;
};

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ onPreviewExpand }) => {
  const { t } = useTranslate();

  return (
    <div className={styles.showMoreButtonContainer}>
      <button
        type="button"
        data-hook={CONTENT_TOGGLE_BUTTON}
        className={styles.showMoreButton}
        onClick={() => onPreviewExpand?.()}
      >
        {t('post-content.show-more')}
        <ChevronDown />
      </button>
    </div>
  );
};
